import ReactDOM from "react-dom";
import "./styles/index.scss";
// import "./index.css";
import './daisyUI/index.css';
import App from "./App";
import { ConfigProvider } from "./context/Config/ConfigProvider";

ReactDOM.render(<ConfigProvider><App /></ConfigProvider>, document.getElementById("root"));
